import { render, staticRenderFns } from "./DetalleCliente.vue?vue&type=template&id=3e3953aa&scoped=true"
import script from "./DetalleCliente.vue?vue&type=script&lang=js"
export * from "./DetalleCliente.vue?vue&type=script&lang=js"
import style0 from "./DetalleCliente.vue?vue&type=style&index=0&id=3e3953aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3953aa",
  null
  
)

export default component.exports